import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

export default function AccContactPer({ accDetails }) {
    return (
        <div>
            <h2 className='orgAccountH2'>Contact Person</h2>
            <div className='orgAccountSecDiv'>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Name'
                        answer={accDetails?.contactPerson?.name}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Email Id'
                        answer={accDetails?.contactPerson?.emailId}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Country Code'
                        answer={accDetails?.contactPerson?.countryCode}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Phone Number'
                        answer={accDetails?.contactPerson?.phoneNumber}
                        className='borderNone width50'
                    />
                </div>
            </div>
        </div>
    );
}
